import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent } from '@ionic/react'
import { UseHeader, MktEmpty, ResultAlert, CouponItem } from '@cps'
import { memberMobx } from '@mobxStore'
import ActivityApi from '@api/activity.api'
import PrizeItem from '../components/PrizeItem'
import { modalLayer, useHistoryNew } from '@utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const MyPrizes: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { activityId } = match.params as any
  const [prizes, setPrizes] = useState<any>([])
  const [couponDetails, setCouponDetails] = useState<any>({})
  const goBack = () => {
    history.goBack()
  }
  const transCoupons = (list: any) => {
    const couponIds: any = []
    list.map((item) => {
      item.coupons.map((coup) => {
        if (!couponIds.includes(coup.couponId)) {
          couponIds.push(coup.couponId)
        }
      })
    })
    ActivityApi.getCouponsList({ couponIds: couponIds, status: 'all' }).then(res => {
      const obj = keyBy(res, 'couponId')
      setCouponDetails(obj)
    })
  }
  const showRecord = (prizeInfo: any) => {
    modalLayer(ResultAlert, {
      title: prizeInfo.sendValue,
      btnTitle: i18n.t('pay.acknowledged'),
      children: prizeInfo && prizeInfo.coupons.map((item: any, index: number) => {
        const hasItem: any = couponDetails[item.couponId]
        return hasItem && (
          <div className='coupon-block' key={`${index}-${item.couponId}`}>
            <CouponItem type='use' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
          </div>)
      })
    }).then(() => { }, () => { })
  }
  useEffect(() => {
    ActivityApi.getPrizes({ brandId: memberMobx.brandId, activityId: activityId }).then((res: any) => {
      if (res.length > 0) {
        setPrizes(res.reverse())
        transCoupons(res)
      }
    })
  }, [])
  return (
    <IonPage className='active-prizes-page'>
      <UseHeader title={i18n.t('mkt.activity.myPrize')} onBack={goBack}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          {
            prizes.length > 0 ? (
              <>
                {
                  prizes && prizes.map((item: any, index: number) => {
                    return (
                      <PrizeItem
                        key={index} info={item} couponMap={couponDetails} onClick={() => {
                          showRecord(item)
                        }}
                      >
                      </PrizeItem>)
                  })
                }
              </>) : <MktEmpty text={i18n.t('mkt.activity.noPrizes')}></MktEmpty>
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(MyPrizes)
